const formatCharacters = ['[\u2000-\u2011]', '[\u205f-\u206f]', '\t', '\r', '\n'];
const formatCharacterRegex = new RegExp(`${formatCharacters.join('|')}`, 'g');

export function sanitizeFormatCharacters(str) {
  return str ? str.replace(formatCharacterRegex, '').trim() : str;
}
